import { get, post } from "./Api";

export function SearchQuestionnaire({ params }) {
  return get({ url: `/searchQuestionnaire`, params });
}

export function CreateUserAnswer({ data }) {
  return post({ url: `/createUserAnswer`, data });
}